export default {
  getAll (state) {
    return state.accounts
  },

  getAccount (state) {
    return state.account
  },

  updatedAccount (state) {
    return state.account_status
  },

  deletedAccount (state) {
    return state.deletedAccount
  },

  pixelTrackingDetails (state) {
    return state.pixelTrackingDetails
  },

  getTrackingDebugKey (state) {
    return state.trackingDebugKey
  }
}
